import { EventBase, EventPayloadBase } from '@lifeway/frontend-analytics';

const Domain = 'curriculum';
const CurriculumEventType = 'Curriculum Interaction';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export abstract class CurriculumEventBase<Context extends EventPayloadBase<any>> extends EventBase<
  typeof CurriculumEventType,
  typeof Domain,
  Context
> {
  get domain(): typeof Domain {
    return Domain;
  }

  protected get expectedEventType(): typeof CurriculumEventType {
    return CurriculumEventType;
  }
}
